import {
  Box,
  Paper,
  Typography,
  Button,
  useTheme
} from '@mui/material';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import LoginIcon from '@mui/icons-material/Login';

function SessionExpired({ onBackToLogin }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f9fa',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            'linear-gradient(30deg, transparent 20%, rgba(25, 118, 210, 0.1) 40%, transparent 60%), linear-gradient(150deg, transparent 40%, rgba(25, 118, 210, 0.08) 50%, transparent 60%), linear-gradient(270deg, transparent 10%, rgba(25, 118, 210, 0.12) 45%, transparent 90%)',
          zIndex: 0
        }
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.67)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          maxWidth: 480,
          width: '100%',
          mx: 2,
          textAlign: 'center',
          position: 'relative',
          zIndex: 1
        }}
      >
        <TimerOffIcon
          sx={{
            fontSize: 64,
            color: theme.palette.warning.main,
            mb: 2
          }}
        />

        <Typography
          variant="h5"
          component="h1"
          fontWeight="bold"
          sx={{ color: theme.palette.text.primary, mb: 1 }}
        >
          Session expirée
        </Typography>
        <Typography
          variant="h5"
          component="h1"
          fontWeight="bold"
          sx={{ color: theme.palette.text.primary, mb: 1 }}
        >
          Sessie verlopen
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: theme.palette.text.secondary, mb: 1 }}
        >
          Votre session a expiré pour des raisons de sécurité.
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: theme.palette.text.secondary, mb: 4 }}
        >
          Uw sessie is om veiligheidsredenen verlopen.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<LoginIcon />}
          onClick={onBackToLogin}
          sx={{
            py: 1.5,
            px: 4,
            borderRadius: 2,
            fontWeight: 'bold',
            textTransform: 'none',
            fontSize: '1rem'
          }}
        >
          Se reconnecter / Opnieuw aanmelden
        </Button>
      </Paper>
    </Box>
  );
}

export default SessionExpired;
